import React from 'react';
import PropTypes from 'prop-types';
import Popup from './Popup';
import PopupHeader from './PopupHeader';
import PopupFooter from './PopupFooter';
import { I18n } from 'react-redux-i18n';
import Validation from '../../helpers/Validation';

class SingleInputPopup extends React.Component {
  state = {
    message: '',
  };
  inputRef = React.createRef();

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isShow && this.props.isShow) {
      this.setState({
        message: '',
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShow } = this.props;
    if (!isShow && prevProps.isShow) {
      this.clearInput();
    }
  }

  renderHeader = () => {
    const { title } = this.props;

    return <PopupHeader title={title} />;
  };

  onInputKeyDown = e => {
    if (e.key === 'Enter') {
      this.handleConfirm(true);
    }
  };

  renderBody = () => {
    const { placeHolder } = this.props;
    const { message } = this.state;

    return (
      <>
        <div className="form-group">
          <input
            onKeyDown={this.onInputKeyDown}
            type="text"
            className="form-control"
            placeholder={I18n.t(placeHolder)}
            ref={this.inputRef}
          />
          <button className="btn-cancel-search" type="button">
            <i className="icon-cancel" onClick={this.clearInput} />
          </button>
        </div>
        {message.length > 0 && (
          <div style={{ color: '#eb505a', marginTop: -15 }}>{message}</div>
        )}
      </>
    );
  };

  renderFooter = () => {
    const { titleYes, titleNo } = this.props;

    return (
      <PopupFooter
        confirm={this.handleConfirm}
        enabledApply={true}
        enabledCancel={true}
        titleYes={titleYes}
        titleNo={titleNo}
      />
    );
  };

  clearInput = () => {
    this.inputRef.current.value = '';
    this.inputRef.current.focus();
  };

  validateLayoutName = name => {
    const validation = new Validation(name);
    return validation
      .isEmpty()
      .startWithAlphabetOrNumber()
      .limitCharacter(50).messages;
  };

  handleValidateInput = errorMessage => {
    const [first] = errorMessage;
    if (errorMessage.length > 0) {
      this.setState({ message: [first] });
    } else {
      this.setState({ message: '' });
    }
  };

  handleConfirm = isApply => {
    const { confirm, isCheckValidate } = this.props;
    const inputVal = this.inputRef.current ? this.inputRef.current.value : '';

    if (isCheckValidate) {
      const errorMessage = this.validateLayoutName(inputVal);
      this.handleValidateInput(errorMessage);
      if (errorMessage.length > 0 && isApply === true) {
        return;
      }
    }

    return confirm(isApply, inputVal);
  };

  render() {
    const { isShow } = this.props;

    return (
      <Popup
        isShow={isShow}
        confirm={this.handleConfirm}
        renderHeader={this.renderHeader}
        renderBody={this.renderBody}
        renderFooter={this.renderFooter}
      />
    );
  }
}

SingleInputPopup.propTypes = {
  title: PropTypes.string.isRequired,
  placeHolder: PropTypes.string.isRequired,
  isShow: PropTypes.bool.isRequired,
  confirm: PropTypes.func.isRequired,
  titleYes: PropTypes.string,
  titleNo: PropTypes.string,
  isCheckValidate: PropTypes.bool,
};

SingleInputPopup.defaultProps = {
  title: '',
  placeHolder: '',
  isShow: false,
  confirm: () => {},
  titleYes: 'common.YES',
  titleNo: 'common.CANCEL',
  isCheckValidate: false,
};

export default SingleInputPopup;
